import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  { path: 'organizations', lazy: async () => ({ Component: (await import('./OrganizationsPage')).OrganizationsPage }) },
  { path: 'organizations/:organizationId', lazy: async () => ({ Component: (await import('./OrganizationPage')).OrganizationPage }) },
];
